"use client";

import { Slot } from "@radix-ui/react-slot";
import type { PropsWithChildren } from "react";
import {
	ClientAccordionContent,
	ClientAccordionItem,
	ClientAccordionRoot,
	ClientAccordionTrigger,
} from "~/components/ui/Accordions/Accordion/Accordion";
import styles from "./details.module.css";

export type DetailItem = {
	id?: string;
	name: string;
	title: string;
	content: React.ReactNode;
	hide?: boolean;
};
export interface DetailsAccordionProps {
	data: DetailItem[];
}

/**
 * Details accordion for PDP display
 */
export const DetailsAccordion = ({ data }: DetailsAccordionProps) => {
	return (
		<ClientAccordionRoot className={styles.accordion}>
			{data
				?.filter(({ hide = false }) => !hide)
				.map((item, i) => (
					<ClientAccordionItem key={i} className={styles.details} id={item.id}>
						<ClientAccordionTrigger>{item.title}</ClientAccordionTrigger>
						<ClientAccordionContent>{item.content}</ClientAccordionContent>
					</ClientAccordionItem>
				))}
		</ClientAccordionRoot>
	);
};

export const DetailText = ({
	children,
	asChild = false,
}: PropsWithChildren<{
	asChild?: boolean;
}>) => {
	const Component = asChild ? Slot : "p";
	return <Component className={styles.detailText}>{children}</Component>;
};
